import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/InvoiceCard.css";
import { ToastContainer, toast } from 'react-toastify';
import { saveInvoiceDispatchs } from '../Api/InvoiceApi'
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../Context/AuthContext";

const InvoiceDispatchDetails = () => {
    const { invoiceId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();


    console.log(user, 'user')


    const [formData, setFormData] = useState({
        ewayBillNumber: "",
        ewayBillDate: "",
        lrNumber: "",
        lRDate: "",
        dispatchDate: "",
        cases: "",
        transporterName: "",
        transportMode: "",
        destination: "",
        vehicleNumber: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await saveInvoiceDispatchs(formData, user?.userId, invoiceId);
            if (response.status === 200) {
                toast.success('Details Update Successfully')
                navigate('/viewpostedInvoice')
            }
            console.log(response, 'response from invoice dis')

        } catch (err) {
            console.log(err, 'err to')
            toast.error('Some Error Happens')
        }
        // console.log('sdfhjdghdj')
    }
    return (
        <>
            <div className="container-fluid py-4">
                <div className="card shadow-sm border-0 rounded-4 p-4 mb-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="fw-bold text-dark mb-1">
                                Dispatch Details - Invoice #{invoiceId}
                            </h4>
                            <p className="text-muted mb-2">
                                Enter dispatch details
                            </p>
                        </div>
                    </div>
                </div>
                <div className="card shadow-sm border-0 rounded-4 p-4 invoice-header-card">
                    <div className="d-flex align-items-center mb-4">
                        <div className="icon-box me-2">
                            📄
                        </div>
                        <h5 className="fw-bold mb-0 text-dark">Invoice Header Details</h5>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    E-Way Bill Number <span className="text-danger">*</span>
                                    <span className="ms-1 text-muted" title="ewayBillNumber">?</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="ewayBillNumber"
                                    name="ewayBillNumber"
                                    value={formData.ewayBillNumber}
                                    onChange={handleChange}
                                    required
                                    maxLength={12}
                                // max={12}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    E-way Bill Date <span className="text-danger">*</span>
                                    <span className="ms-1 text-muted" title="ewayBillDate">?</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="ewayBillDate"
                                    name="ewayBillDate"
                                    value={formData.ewayBillDate}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    LR Number
                                    <span className="ms-1 text-muted" title="lrNumber">?</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="lrNumber"
                                    name="lrNumber"
                                    value={formData.lrNumber}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    LR Date
                                    <span className="ms-1 text-muted" title="LR Date">?</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="lRDate"
                                    name="lRDate"
                                    value={formData.lRDate}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="row g-3 mt-0">
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    Dispatch Date <span className="text-danger">*</span>
                                    <span className="ms-1 text-muted" title="dispatchDate">?</span>
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="dispatchDate"
                                    name="dispatchDate"
                                    value={formData.dispatchDate}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    Cases
                                    <span className="ms-1 text-muted" title="cases">?</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-select"
                                    id="cases"
                                    name="cases"
                                    value={formData.cases}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    Transporter Name
                                    <span className="ms-1 text-muted" title="Transporter Name">?</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="transporterName"
                                    name="transporterName"
                                    value={formData.transporterName}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    Transport Mode
                                    <span className="ms-1 text-muted" title="Transport Mode">?</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="transportMode"
                                    name="transportMode"
                                    value={formData.transportMode}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="row g-3 mt-0">
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    Destination <span className="text-danger">*</span>
                                    <span className="ms-1 text-muted" title="destination">?</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="destination"
                                    name="destination"
                                    value={formData.destination}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-semibold">
                                    Vehicle Number
                                    <span className="ms-1 text-muted" title="vehicleNumber">?</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="vehicleNumber"
                                    name="vehicleNumber"
                                    value={formData.vehicleNumber}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center mt-4">
                            <button
                                type="submit"
                                className="btn btn-primary rounded-3 fw-semibold px-4"
                            >
                                Enter Dispatch
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default InvoiceDispatchDetails